// extracted by mini-css-extract-plugin
module.exports = {"themeColor":"#2c81b9","subColor":"#23afd0","white":"#fff","headerHeight":"40"};